import { makeAutoObservable } from "mobx";
import { ErrorBox, TextFieldController } from "../../form";
import { t, translate } from "../../I18n";
export class BlikCodeFormController {
    constructor({ state }) {
        this.state = state;
        this.code = new TextFieldController({
            onUpdate: (v) => this.state.updateValue(v),
            errorBox: new ErrorBox({
                domainObjects: [this.state],
                errorMessages: {
                    InvalidBlikCode: translate(t.orders.checkout.blik_level_0.code_error),
                    BlikCodeServerError: () => { var _a; return (_a = this.state.serverErrors[0]) !== null && _a !== void 0 ? _a : ""; },
                },
            }),
        });
        makeAutoObservable(this);
    }
    get fields() {
        return { code: this.code };
    }
    get value() {
        return this.fields.code.value;
    }
    get isTouched() {
        return this.fields.code.isTouched;
    }
    get isDirty() {
        return this.fields.code.isDirty;
    }
    get errors() {
        return this.fields.code.errors;
    }
    get isInvalid() {
        return this.fields.code.isInvalid;
    }
    get isValid() {
        return this.fields.code.isValid;
    }
    submit() {
        this.fields.code.blur();
    }
    touch() {
        this.fields.code.blur();
    }
    clear() {
        this.fields.code.clear();
    }
    clearServerErrors() {
        this.state.clearServerErrors();
    }
    setServerErrors(errors) {
        this.state.setServerErrors(errors);
    }
}
